import { CheckboxInput, FormItem } from '@framework/form';
import React from 'react';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.Positive}`;

export interface IPositiveRuleComponentProps {}

export function PositiveRuleComponent(props: IPositiveRuleComponentProps) {
  return (
    <FormItem
      name={`${fieldName}.value`}
      label={null}
      layout={{ removeMargin: true }}
      help="I valori inseriti devono essere strettamente maggiori di zero. Se si vuole includere lo zero fra i valori ammessi, utilizzare il campo 'minimo' e impostarlo a zero."
    >
      <CheckboxInput name={`${fieldName}.value`} defaultChecked={false}>
        Solo numeri positivi
      </CheckboxInput>
      <CustomValidationRuleMessage
        isGhostType
        name={`${fieldName}.customMessage`}
      />
    </FormItem>
  );
}
